import React, { useState } from 'react'
import { Typography } from 'antd'
import Select from 'react-select'
import { useSnackbar } from 'notistack'
import { useListData, usePet, notifOps } from '../../modules'

import Modal from "../reusable/modal"
import Confirm from '../reusable/confirm'

const { Paragraph } = Typography

const SaleItemPrices = ({ toggle, visible, item, onPerform, type = 'Sale Item' }) => {
    const [lists, setLists] = useState([])
    const [itm, setItem] = useState()
    const [val, setVal] = useState()
    const [selected, setList] = useState()

    const { enqueueSnackbar } = useSnackbar()

    const [, getPriceLists] = usePet('priceLists', { limit: 100 }, { notify: true, manual: true, callback: async ({ data }) => {
        data.lists = data.lists.map(list => {
            let eq = itm?.prices?.find(entry => entry?.priceList?._id === list?._id)
            list.price = eq?.price ?? 0
            list.formula = eq?.pricingFormula ?? ''
            list.type = { label: eq?.pricingType ?? "Direct Price", value: eq?.pricingType ?? "Direct Price" }

            return list
        })

        setLists(data?.lists)
    } })

    let types = ['Direct Price', 'Computed Price']

    const [, getSaleItem] = usePet('singleSaleItem', { id: item?._id }, { notify: true, callback: async ({ data }) => {
        setItem(data) 
        getPriceLists()
    } })

    const close = () => {
        toggle()
    }

    const callback = (_, notify, ops) => {
        notify('Changes have been saved', ops('success'))
        getSaleItem()
        setTimeout(close, 300)
        onPerform()
    }

    const [{ loading }, execute] = usePet('editSaleItemPriceList', {
        id: itm?._id,
        lists: lists.map(list => ({
            name: list.name,
            priceList: list._id,
            pricingType: list?.type?.value,
            pricingFormula: list?.formula,
            price: list.price
        }))
    }, { notify: true, load: { msg: "Saving changes" }, callback, manual: true })

    const editPrice = (vl, i) => {
        let temp = [...lists]

        if (!isNaN(vl) && vl !== null && vl !== undefined) {
            temp[i].price = vl
            setLists(temp)
        } else {
            enqueueSnackbar('Please enter the a numerical value', notifOps('warning'))
        }            
    }

    const editType = (vl, i) => {
        let temp = [...lists]
        temp[i].type = vl
        temp[i].price = 0
        temp[i].formula = ''
        setLists(temp)
    }

    const editFormula = (vl, i) => {
        let test = vl.replace('bp', 100)
        
        try {
            let resp = eval(test)
            if (isNaN(resp)) {
                enqueueSnackbar('Please enter a valid formula', notifOps('warning'))
            } else {
                let temp = [...lists]
                temp[i].formula = vl
                setLists(temp)
            }
        } catch (error) {
            enqueueSnackbar('Please enter a valid formula', notifOps('warning'))
        }
    }

    const save = () => Confirm({
        title: 'Save Changes?',
        message: 'Please confirm before proceeding?',
        okText: 'Proceed',
        onOk: execute
    })
    
    return (
        <Modal
            w={ 500 }
            toggle={close}
            centered={ false }
            title="Edit Prices"
            visible={visible}>
            <p className="text-gray-500 text-xs mt-0">Available variables: (bp)</p>
            <div className="divide-y divide-light-gray-400">
                <div className="font-bold mt-3">
                    {
                        lists.length > 0 ?
                            <table className="table-auto w-full mb-3">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">List</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Type</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Price</div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        lists.map((list, key) => 
                                            <tr>
                                                <td className="p-2 text-left">{key + 1}</td>
                                                <td className="p-2 text-left">{list?.name}</td>
                                                <td className="p-2 text-left">
                                                    <Select
                                                        className="w-40"
                                                        value={ list.type }
                                                        onChange={ v => editType(v, key) }
                                                        options={ types.map(type => ({ label: type, value: type })) } />
                                                </td>
                                                <td className="p-2 text-left">
                                                    {
                                                        list?.type?.value === 'Direct Price' ?
                                                            <input
                                                                className="appearance-none w-40 block bg-gray-200 text-center text-gray-700 border border-gray-200 rounded py-3 px-4 mr-2 leading-tight focus:outline-none focus:bg-white"
                                                                value={ list?.price }
                                                                placeholder='Enter price'
                                                                onChange={ e => editPrice(e.target.value, key) }
                                                                type="number" />
                                                        :
                                                            <input
                                                                className="appearance-none w-40 block bg-gray-200 text-center text-gray-700 border border-gray-200 rounded py-3 px-4 mr-2 leading-tight focus:outline-none focus:bg-white"
                                                                defaultValue={ list?.formula }
                                                                placeholder='(bp * 1.33) + 100'
                                                                onBlur={ e => editFormula(e.target.value, key) }
                                                                type="text" />
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="text-center my-4">
                                <h3>Please use the price list section on the menu to add new price list.</h3>
                            </div>
                    }
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button onClick={ save } type="submit" className="text-white hisani-btn-orange-light font-medium rounded-lg text-sm mr-2 px-5 py-2.5 text-center">Save</button>
                <button onClick={ close } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default SaleItemPrices